import * as React from 'react';
import * as CopyToClipboard from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';
import styled from 'styled-components';

import { Icons } from 'src/components';

interface ICopyButtonProps extends React.HTMLProps<HTMLElement> {
  toCopy: string;
  successMessage?: string;
}

const StyledButton = styled.button.attrs(({ className }) => ({
  className: `text-black focus:outline-none ${className}`,
}))`
  color: ${(props) => props.theme.primary};
  &:hover {
    color: ${(props) => props.theme.secondary};
  }
`;

class CopyButton extends React.Component<ICopyButtonProps> {
  onCopy = (_: string, success: boolean) => {
    if (success) {
      toast.success(this.props.successMessage || 'Copied', { autoClose: 1200 });
    } else {
      toast.error('Copy failed', { autoClose: 1200 });
    }
  };

  render() {
    return (
      <CopyToClipboard text={this.props.toCopy} onCopy={this.onCopy}>
        <StyledButton className={this.props.className || ''}>
          <Icons.Copy />
        </StyledButton>
      </CopyToClipboard>
    );
  }
}

export default CopyButton;



// WEBPACK FOOTER //
// ./src/components/CopyButton.tsx